import { render, staticRenderFns } from "./ContactFooter.vue?vue&type=template&id=c262e7f4&scoped=true"
import script from "./ContactFooter.vue?vue&type=script&lang=js"
export * from "./ContactFooter.vue?vue&type=script&lang=js"
import style0 from "./ContactFooter.vue?vue&type=style&index=0&id=c262e7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c262e7f4",
  null
  
)

export default component.exports